window.addEventListener('DOMContentLoaded', function() {

	//lang属性を取得
	const documentLang = document.documentElement.lang;

	//dir属性を取得
	const documentDir = document.documentElement.dir;

	//HTMLの言語属性とそれに対応する名称
	const langLists = [
		{lang:"en-US",name : "EN"}
		,{lang:"ar",name : "AR"}
		,{lang:"es",name : "ES"}
		,{lang:"fr",name : "FR"}
		,{lang:"ko",name : "KO"}
		,{lang:"pt",name : "PT"}
		,{lang:"vi",name : "VI"}
		,{lang:"th",name : "TH"}
		,{lang:"zh-CN",name : "ZH-CN"}
		,{lang:"zh-TW",name : "ZH-TW"}
		,{lang:"de",name : "DE"}
		,{lang:"it",name : "IT"}
		,{lang:"nl",name : "Nl"}
		,{lang:"ru",name : "RU"}
		,{lang:"ja",name : "JA"}

	];

	const currentLang = langLists.find((langList)=>{
		return langList.lang == documentLang;
	});

	//現在の言語を表示
	document.querySelector(".header-langs__current").innerHTML = currentLang.name;

	//言語が英語以外の場合、翻訳の注意文を表示させる
	if(documentLang == "en-US") {
		document.querySelector(".footer__lang-message").setAttribute("style","display:none");
	}

	//dir属性がrtlなのに言語がアラビア語ではない場合、ltrに書き換える
	if(documentLang != "ar") {
		document.documentElement.dir = "ltr";
	}

	//dir属性がrtlで、且つ言語がアラビア語の場合、すべての要素のclassにdir-rtlを付与する
	if(documentDir == "rtl" && documentLang == "ar") {
		let classElms = document.querySelectorAll('[class]');
		// querySelectorAllで取得するNodeListは、
		// IE11ではforEachが使えないので、
		// 配列に変換する
		classElms = Array.prototype.slice.call(classElms,0);

		classElms.forEach(classElm =>{
			if(classElm.classList) {
				classElm.classList.add("dir-rtl");
			}
		});
	}
});
